<template>
    <div class="capacity-tab">
        <div class="tabulation-title" v-if="capacities.length" :style="'color:' + titlesColor">
            <h5>
                {{ index }}. Capacités
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="mt-3 d-flex justify-content-between flex-wrap">
                <div v-for="capacity in capacities" class="capacity-block mb-3 mx-1" style="width: 350px">
                    <label :style="'color:' + fieldsColor" :class="{'required': isRequiredName('Capacites')}">
                        {{ capacity.label }}
                    </label>
                    <v-text-field
                            v-model.number="capacity.value"
                            type="number"
                            step="2"
                            min="0"
                            hide-details
                            @keydown="filterInput"
                            outlined
                            :class="{'input-error': submitted && isRequiredName('Capacites')
                        && (capacity.value === null || capacity.value === '' || capacity.value === undefined)}"
                    >
                    </v-text-field>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex"

export default {
    name: "Capacities",
    props: ['index'],
    methods: {
        mergeProviderCapacities() {
            this.provider.capacities.forEach(capacity => {

                if (capacity.element !== undefined) {
                    let element = this.capacities.find(elt => elt.id === capacity.element.id)

                    if (element !== undefined) {
                        this.$set(element, 'value', capacity.value)
                    }
                }
            })
        },
        updateProviderCapacities() {
            this.provider.capacities = this.capacities.filter(capacity => {
                return capacity.value !== undefined && capacity.value !== ''
            })
        },
        isRequiredName(name) {
            return this.getRequiredFields.find(field => field.fieldable.name === name)
        },
        filterInput(event) {
            const invalidChars = ['e', 'E', '+', '-']

            if (invalidChars.includes(event.key)) {
                event.preventDefault()
            }
        },
    },
    computed: {
        ...mapState('web_form', ['provider', 'capacities', 'disabled', 'fields', 'submitted']),
        ...mapState('webFormStyle', ['titlesColor', 'fieldsColor']),
        ...mapGetters('web_form', ['getRequiredFields'])
    },
    watch: {
        capacities: {
            handler() {
                this.updateProviderCapacities()
            },
            deep: true
        }
    },
    created() {
        this.mergeProviderCapacities()
    }
}
</script>